import { subCategoryResultCreateSchema } from "@/schema/console/improvement-proposals/SubCategoryResultCreate";
import { z } from "zod";

export const improvementProposalCreateSchema = z.object({
  sub_category_results: z.array(subCategoryResultCreateSchema),
});

export type ImprovementProposalCreate = z.infer<
  typeof improvementProposalCreateSchema
>;
